module.exports = __webpack_public_path__ + "img/user.8feff939.png";